import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import FeasibilityStudyData from './data';

const FeasibilityStudy = () => {
  return <ProjectDetailView data={FeasibilityStudyData} />;
};

export default FeasibilityStudy;
